import { useNextSupportMessageModal } from "./useNextSupportMessageModal";

import type { ReactNode } from "react";

/**
 * Render the blocking modals that should be shown when the user navigates to a company route one by one.
 *
 * @returns The modal to be shown currently, or null if no modal should be shown.
 */
export const CompanyRouteModalQueue = (): ReactNode => {
	// Invoke all the relevant modal hooks and call the relevant APIs in one go.
	const supportMessageModal = useNextSupportMessageModal();

	return supportMessageModal || null;
};
